(function(){
  function init(){
    var root=document.querySelector('[data-pde-quote-product]');
    if(!root)return;
    var backLink=root.querySelector('[data-pde-product-back]');
    if(backLink){
      var category=null;
      var page=1;
      try{
        var params=new URLSearchParams(window.location.search);
        category=params.get('catalogue_category');
        page=parseInt(params.get('catalogue_page'),10)||1;
        if(!category&&document.referrer.indexOf(window.location.origin+'/collections/all')===0){
          var saved=JSON.parse(window.sessionStorage.getItem('pdeCatalogueState')||'null');
          if(saved){category=saved.category;page=saved.page||1;}
        }
      }catch(e){}
      if(category){
        var hash='#category='+encodeURIComponent(category);
        if(page>1){hash+='&page='+page;}
        backLink.href='/collections/all'+hash;
        var labels={
          'chairs-stools':'Operatory Chairs & Stools',
          'operatory-packages':'Operatory Packages',
          'pediatric':'Pediatric',
          'orthodontic':'Orthodontic',
          'delivery-systems':'Delivery Systems',
          'syringes':'Syringes',
          'hve-saliva':'HVE & Saliva Ejectors',
          'water-bottle-systems':'Water Bottle Systems',
          'parts':'Parts & Accessories',
          'vacuums':'Vacuum Systems',
          'compressors':'Compressors',
          'sterilizers':'Sterilizers',
          'instrument-care':'Instrument Care',
          'imaging':'Imaging',
          'mechanical-room':'Mechanical Room'
        };
        backLink.textContent='← Back to '+(labels[category]||category.replace(/-/g,' '));
      }
    }

    var form=root.querySelector('[data-quote-product-form]');
    var toast=root.querySelector('[data-pde-quote-toast]');
    if(!form||!toast)return;
    var message=toast.querySelector('[data-pde-quote-toast-message]');
    var destination=root.hasAttribute('data-pde-order-online')?'cart':'quote list';
    var submit=form.querySelector('button[type="submit"]');
    var close=function(){toast.style.display='none';toast.setAttribute('hidden','hidden');};
    toast.addEventListener('click',function(event){
      if(event.target.closest('[data-pde-quote-toast-close]'))close();
    });
    document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!toast.hasAttribute('hidden'))close();});

    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(submit&&submit.getAttribute('aria-busy')==='true')return;
      var data=new FormData(form);
      var quantity=parseInt(data.get('quantity'),10)||1;
      if(submit){submit.setAttribute('aria-busy','true');submit.disabled=true;}
      fetch('/cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}})
        .then(function(response){
          if(!response.ok)throw new Error('Quote item could not be added');
          return response.json();
        })
        .then(function(){
          return fetch('/cart.js',{headers:{Accept:'application/json'}});
        })
        .then(function(response){
          if(!response.ok)throw new Error('Quote list could not be refreshed');
          return response.json();
        })
        .then(function(cart){
          document.querySelectorAll('.cart-count').forEach(function(count){
            count.textContent=cart.item_count;
            count.classList.toggle('hidden-count',cart.item_count===0);
            count.classList.toggle('empty',cart.item_count>=100);
          });
          message.textContent=quantity+' '+(quantity===1?'item':'items')+' added. Keep shopping or review your '+destination+'.';
          toast.style.display='';
          toast.hidden=false;
          toast.focus({preventScroll:true});
        })
        .catch(function(){
          HTMLFormElement.prototype.submit.call(form);
        })
        .finally(function(){
          if(submit){submit.removeAttribute('aria-busy');submit.disabled=false;}
        });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();